<template lang="pug">
div
  breadcrumbs-layout(:breadcrumbs="crumbs")
    article-page(
      :name="pageTitle"
      :article="pageText"
    )
</template>

<script>
import { Breadcrumbs as BreadcrumbsLayout } from 'elysium-common/components/layout';
import { Articlehtml as ArticlePage } from '@/components/parts/article';

import mixin from '@/pages/breadcrumb-mixin.js';
import routeProps from '@/mixins/routeProps.js';

import {
  PAGE_NAME,
  DESCRIPTION_PAGE,
  KEY_WORDS,
} from './const.js';

const textHtml = require('raw-loader!./text.html');

export default {
  mixins: [
    mixin,
    routeProps,
  ],

  components: {
    BreadcrumbsLayout,
    ArticlePage,
  },

  data: () => ({
    pageTitle: PAGE_NAME,
    pageText: textHtml,
  }),

  computed: {
    crumbs() {
      return this.breadcrumbs.concat([{text: PAGE_NAME}]);
    },
  },

  metaInfo() {
    return {
      title: PAGE_NAME,
      meta: [
        {vmid: 'description', name: 'description', content: DESCRIPTION_PAGE},
        {vmid: 'keywords', name: 'keywords', content: KEY_WORDS}
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// Info.vue?3c39b6de